(function () {
    'use strict';

    angular
        .module('app')
        .controller('ManageUsersEmailController', ManageUsersEmailController);

    ManageUsersEmailController.$inject = ['$modalInstance', 'email', 'authentication'];

    function ManageUsersEmailController($modalInstance, email, authentication) {
        var vm = this;

        vm.email = email;

        vm.onSubmit = onSubmit;

        function onSubmit() {
            vm.isWaiting = true;
            authentication.changeLoginEmail({
                identifier: vm.email,
                email: vm.newEmail,
                adminEditing: true
            }).then($modalInstance.close).catch(function (error) {
                vm.formError = error;
                vm.isWaiting = false;
            });
        }
    }
})();